import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { MouseEventHandler } from "react";
import { FILTERS } from "../../data/filtersList";
import styles from "./badge.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";

export type FilterNameType = (typeof FILTERS)[number]["name"] | "Filters";

type BadgeProps = {
  value: string;
  activeLabel?: string | false;
  isActive?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  icon?: ({ fill }: { fill?: string | undefined }) => JSX.Element;
  count?: number;
  invertActiveColor?: boolean;
  invertColor?: boolean;
  showIconOnRight?: boolean;
  className?: any;
  fromSearchRegionPage?: boolean;
  isDesktop?: boolean;
  dataTestId?: string;
  hidden?: boolean;
  isRentInstallment?: boolean;
  ref?: any;
};

const Badge = ({
  value,
  activeLabel = false,
  isActive = false,
  onClick,
  icon: Icon,
  count,
  className = "",
  invertActiveColor = false,
  invertColor = false,
  showIconOnRight = false,
  fromSearchRegionPage = false,
  isDesktop = false,
  dataTestId,
  hidden = false,
  ref,
}: BadgeProps) => {
  const { t } = useTranslationHook();
  const tValue = t(value);
  const { isWhitelabel, whitelabelColors } = useWhitelabel();
  const ACTIVE_COLOR = isWhitelabel ? whitelabelColors?.accessible_brand_color : "#ED3A56";

  return (
    <>
      <button
        ref={ref}
        type="button"
        className={formatClassNames(
          styles.container,
          isActive && styles.isActive,
          invertActiveColor && styles.invertActiveColor,
          invertColor && styles.invertColor,
          className,
          fromSearchRegionPage &&
            (isDesktop ? styles.searchRegionDesktopBadge : styles.searchRegionBadge),
          hidden && styles.hidden,
        )}
        onClick={onClick}
        data-testid={dataTestId}
        // {...(isWhitelabel &&
        //   isActive && {
        //     style: {
        //       backgroundColor: whitelabelTheme?.isBrandThemeLight
        //         ? whitelabelColors?.brand_color_1
        //         : "#F0F0F0",
        //     },
        //   })}
      >
        {Icon && !showIconOnRight && <Icon {...(isActive && { fill: ACTIVE_COLOR })} />}
        <span data-testid={`Property-Room-Type-filter-${value}`}>
          {activeLabel && activeLabel !== "" ? activeLabel : tValue}{" "}
          {Boolean(count) && <>({count})</>}
        </span>
        {Icon && showIconOnRight && <Icon {...(isActive && { fill: ACTIVE_COLOR })} />}
      </button>
    </>
  );
};

export default wrapperHOC(Badge, {
  componentName: "Badge-FilterSection-SearchPage",
  showForChina: true,
});
